var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5816 5.32027V0L17.9356 2.50787C17.2337 3.17323 16.8395 4.07542 16.8395 5.016V5.32027L17.6605 10.7679C17.7335 11.2525 17.5919 11.7443 17.2694 12.1266L15.2529 14.4573L1.87104 1.77351L0 3.54702L13.5667 16.4062L1.98168 29.7961C1.38623 30.5017 1.4455 31.5188 2.11968 32.1579L3.21564 33.1966C3.9985 33.9385 5.2859 33.8778 5.9868 33.0656L16.5848 21.0401L18.7106 23.0549V23.3594C18.7106 24.3 19.1047 25.2022 19.8067 25.8673L27.2908 32.9613C28.7522 34.3462 31.1215 34.3462 32.5828 32.9613L32.904 32.6568C34.3653 31.2718 34.3653 29.026 32.904 27.6408L24.8717 20.0274C24.5207 19.6949 24.0449 19.5081 23.5488 19.5081H22.4527L19.9911 17.1751L22.5668 14.2524C23.0949 13.6405 23.851 13.2382 24.6768 13.1264C27.8723 12.6937 30.5306 10.5383 31.4581 7.60765C32.2347 5.154 31.3612 2.49879 29.2506 0.898299L28.0658 0V5.32027L24.3237 7.09378L20.5816 5.32027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/Setup.6a378949a5224d6c557b5e78ab9e3164.svg";
export { ForwardRef as ReactComponent };